import {IconNames} from '@wandb/weave/components/Icon';
import {SmallRefLoaded} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/smallRef/SmallRefLoaded';
import {getObjectVersionLabel} from '@wandb/weave/components/PagePanelComponents/Home/Browse3/smallRef/SmallWeaveRef';
import {WeaveObjectRef} from '@wandb/weave/react';
import React, {useMemo} from 'react';

import {useSmallRefPreferredRouter} from './common';

export const SmallOpVersionsRef = ({objRef}: {objRef: WeaveObjectRef}) => {
  const router = useSmallRefPreferredRouter();

  const url = useMemo(
    () =>
      router.opVersionsUIUrl(objRef.entityName, objRef.projectName, {
        opName: objRef.artifactName,
      }),
    [objRef, router]
  );

  const label = useMemo(() => getObjectVersionLabel(objRef, -1), [objRef]);

  return (
    <SmallRefLoaded
      icon={IconNames.JobProgramCode}
      label={label}
      url={url}
      error={null}
    />
  );
};
